import { render, staticRenderFns } from "./HelpCenterSectionView.vue?vue&type=template&id=3c6d21cf&scoped=true"
import script from "./HelpCenterSectionView.vue?vue&type=script&lang=ts"
export * from "./HelpCenterSectionView.vue?vue&type=script&lang=ts"
import style0 from "./HelpCenterSectionView.vue?vue&type=style&index=0&id=3c6d21cf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6d21cf",
  null
  
)

export default component.exports